import React from 'react';
import { Link } from 'react-router-dom';

const Breadcrumb = ({ items }) => {
  return (
    <nav style={{ marginBottom: '16px' }}>
      <ol style={{
        display: 'flex', alignItems: 'center', flexWrap: 'wrap',
        listStyle: 'none', margin: 0, padding: 0, gap: '4px',
      }}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              {index > 0 && (
                <svg style={{ width: 14, height: 14, color: '#9CA3AF', flexShrink: 0 }}
                  fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              )}
              {isLast ? (
                <span style={{ fontSize: '13px', color: '#374151', fontWeight: '500' }}>
                  {item.icon && <span style={{ marginRight: 4 }}>{item.icon}</span>}
                  {item.label}
                </span>
              ) : (
                <Link to={item.to} style={{
                  fontSize: '13px', color: '#6B7280', textDecoration: 'none',
                  display: 'flex', alignItems: 'center', gap: 4,
                }}>
                  {item.icon && <span>{item.icon}</span>}
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
